(function () {
  const CART_POSTCODE_STORAGE_KEY = "deliveryEstimateCartPostcode";
  const FREE_SHIPPING_MINIMUM_CENTS = 50000;

  function calculateShippingFee(orderTotalCents) {
    const priceCents = Number(orderTotalCents || 0);
    return priceCents >= FREE_SHIPPING_MINIMUM_CENTS ? 0 : 100;
  }

  function isCartContext(element) {
    return element && element.closest('[id^="MainCart-"]');
  }

  function openIntercomChat(message) {
    const chatMessage =
      message ||
      "Hi, I would like to request a custom shipping quote for my postcode.";

    function launchChat() {
      if (typeof Intercom !== "function") return false;
      Intercom("showNewMessage", chatMessage);
      return true;
    }

    if (!launchChat()) {
      setTimeout(launchChat, 500);
    }
  }

  function showPlainError(errorDiv, message) {
    if (!errorDiv) return;
    errorDiv.className = "delivery-estimate__error delivery-estimate__error--alert";
    errorDiv.textContent = message;
    errorDiv.style.display = "block";
  }

  function showOutOfZoneError(errorDiv, postcode) {
    if (!errorDiv) return;

    const safePostcode = String(postcode || "").replace(/[^\d]/g, "");
    const truckIcon =
      '<svg class="delivery-estimate__info-card-icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">' +
      '<path d="M13.75 6.25H17.0766C17.2011 6.24994 17.3228 6.28709 17.4261 6.35669C17.5294 6.42629 17.6095 6.52517 17.6562 6.64063L18.75 9.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M1.25 11.25H13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M14.375 16.875C15.4105 16.875 16.25 16.0355 16.25 15C16.25 13.9645 15.4105 13.125 14.375 13.125C13.3395 13.125 12.5 13.9645 12.5 15C12.5 16.0355 13.3395 16.875 14.375 16.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M5.625 16.875C6.66053 16.875 7.5 16.0355 7.5 15C7.5 13.9645 6.66053 13.125 5.625 13.125C4.58947 13.125 3.75 13.9645 3.75 15C3.75 16.0355 4.58947 16.875 5.625 16.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M12.5 15H7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M13.75 9.375H18.75V14.375C18.75 14.5408 18.6842 14.6997 18.5669 14.8169C18.4497 14.9342 18.2908 15 18.125 15H16.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M3.75 15H1.875C1.70924 15 1.55027 14.9342 1.43306 14.8169C1.31585 14.6997 1.25 14.5408 1.25 14.375V5.625C1.25 5.45924 1.31585 5.30027 1.43306 5.18306C1.55027 5.06585 1.70924 5 1.875 5H13.75V13.232" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg>";

    errorDiv.className = "delivery-estimate__error";
    errorDiv.innerHTML =
      '<div class="delivery-estimate__info-card">' +
      '<div class="delivery-estimate__info-card-heading">' +
      truckIcon +
      "<h3>Delivery options for " +
      safePostcode +
      "</h3>" +
      "</div>" +
      "<p>This postcode isn’t listed in our standard delivery details. We’d be happy to explore other options for you.</p>" +
      '<button type="button" class="delivery-estimate__info-card-cta">Request a personalised quote</button>' +
      "</div>";

    const ctaButton = errorDiv.querySelector(".delivery-estimate__info-card-cta");
    if (ctaButton) {
      ctaButton.addEventListener("click", function (event) {
        event.preventDefault();
        openIntercomChat(
          "Hi, I would like to request a custom shipping quote for postcode " +
            safePostcode +
            "."
        );
      });
    }

    errorDiv.style.display = "block";
  }

  function initDeliveryEstimate(blockId, linkText, placeholderText, options) {
    options = options || {};
    const deliveryEstimate = document.getElementById(blockId);
    if (!deliveryEstimate) return;
    if (deliveryEstimate.dataset.deliveryEstimateInitialized === "true") return;
    deliveryEstimate.dataset.deliveryEstimateInitialized = "true";

    const header = deliveryEstimate.querySelector(".delivery-estimate__header");
    const inputWrapper = deliveryEstimate.querySelector(
      ".delivery-estimate__input-wrapper"
    );
    const linkChevron = deliveryEstimate.querySelector(
      ".delivery-estimate__link .delivery-estimate__chevron"
    );
    const locationChevron = deliveryEstimate.querySelector(
      ".delivery-estimate__location-chevron"
    );
    const input = deliveryEstimate.querySelector(".delivery-estimate__input");
    const resultDiv = deliveryEstimate.querySelector(
      ".delivery-estimate__result"
    );
    const errorDiv = deliveryEstimate.querySelector(
      ".delivery-estimate__error"
    );
    const loadingDiv = deliveryEstimate.querySelector(
      ".delivery-estimate__loading"
    );

    if (!header || !inputWrapper) return;

    deliveryEstimate.style.setProperty("padding", "16px", "important");
    deliveryEstimate.style.setProperty("box-sizing", "border-box", "important");

    // Corner Help Centre applies margin-bottom on p/a — force flat layout alignment
    deliveryEstimate
      .querySelectorAll(
        ".delivery-estimate__title, .delivery-estimate__link, .delivery-estimate__pickup-content, .delivery-estimate__pickup-link, .delivery-estimate__header, .delivery-estimate__header-content"
      )
      .forEach(function (el) {
        el.style.setProperty("margin", "0", "important");
        el.style.setProperty("margin-bottom", "0", "important");
        el.style.setProperty("padding-top", "0", "important");
        el.style.setProperty("padding-bottom", "0", "important");
      });

    const pickupRow = deliveryEstimate.querySelector(
      ".delivery-estimate__pickup-row"
    );
    if (pickupRow) {
      pickupRow.style.setProperty("margin", "12px 0 0", "important");
      pickupRow.style.setProperty("margin-bottom", "0", "important");
      pickupRow.style.setProperty("padding-top", "12px", "important");
      pickupRow.style.setProperty("padding-bottom", "0", "important");
    }

    const suggestionsDiv = deliveryEstimate.querySelector(
      ".delivery-estimate__suggestions"
    );
    const suggestionsList = deliveryEstimate.querySelector(
      ".delivery-estimate__suggestions-list"
    );

    let isExpanded = false;
    let debounceTimer = null;
    let autocompleteDebounceTimer = null;
    let hasResult = false;
    let postcodeDataset = null;
    let selectedSuggestionIndex = -1;
    let currentSuggestions = [];

    function toggleExpand() {
      isExpanded = !isExpanded;

      if (isExpanded) {
        inputWrapper.style.maxHeight = "400px";
        inputWrapper.style.paddingTop = "16px";
        header.setAttribute("aria-expanded", "true");
        if (linkChevron) linkChevron.style.transform = "rotate(180deg)";
        if (locationChevron) locationChevron.style.transform = "rotate(180deg)";

        if (hasResult && resultDiv && resultDiv.style.display === "block") {
          // Keep result visible when expanding
        } else {
          const titleText = deliveryEstimate.querySelector(
            ".delivery-estimate__title-text"
          );
          const locationSpan = deliveryEstimate.querySelector(
            ".delivery-estimate__location"
          );

          const link = deliveryEstimate.querySelector(
            ".delivery-estimate__link"
          );

          if (
            titleText &&
            locationSpan &&
            locationSpan.style.display === "inline"
          ) {
            titleText.style.display = "inline";
            locationSpan.style.display = "none";
            // Show "Enter Postcode" link again when expanding to edit
            if (link) {
              link.style.display = "inline-flex";
            }

            if (input && !input.value) {
              input.placeholder = placeholderText;
            }
          }
        }

        setTimeout(() => {
          if (input) input.focus();
          updateSuggestionsPosition();
        }, 300);
      } else {
        inputWrapper.style.maxHeight = "0";
        inputWrapper.style.paddingTop = "0";
        header.setAttribute("aria-expanded", "false");
        if (linkChevron) linkChevron.style.transform = "rotate(0deg)";
        if (locationChevron) locationChevron.style.transform = "rotate(0deg)";
        hideSuggestions();
      }
    }

    function hideAllMessages() {
      if (resultDiv) resultDiv.style.display = "none";
      if (errorDiv) {
        errorDiv.style.display = "none";
        errorDiv.className = "delivery-estimate__error";
        errorDiv.innerHTML = "";
      }
      if (loadingDiv) loadingDiv.style.display = "none";
    }

    function getStateFromPostcode(postcode) {
      const code = parseInt(postcode);
      const stateMapping = {
        NSW: { code: "NSW", name: "New South Wales" },
        VIC: { code: "VIC", name: "Victoria" },
        QLD: { code: "QLD", name: "Queensland" },
        WA: { code: "WA", name: "Western Australia" },
        SA: { code: "SA", name: "South Australia" },
        TAS: { code: "TAS", name: "Tasmania" },
        ACT: { code: "ACT", name: "Australian Capital Territory" },
        NT: { code: "NT", name: "Northern Territory" },
      };

      if ((code >= 2600 && code <= 2618) || (code >= 2900 && code <= 2920)) {
        return stateMapping.ACT;
      } else if (code >= 800 && code <= 999) {
        return stateMapping.NT;
      } else if (code >= 1000 && code <= 2999) {
        return stateMapping.NSW;
      } else if (code >= 3000 && code <= 3999) {
        return stateMapping.VIC;
      } else if (code >= 4000 && code <= 4999) {
        return stateMapping.QLD;
      } else if (code >= 5000 && code <= 5999) {
        return stateMapping.SA;
      } else if (code >= 6000 && code <= 6999) {
        return stateMapping.WA;
      } else if (code >= 7000 && code <= 7999) {
        return stateMapping.TAS;
      }

      return null;
    }

    async function getSuburbFromPostcode(postcode) {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?postalcode=${postcode}&countrycodes=au&format=json&limit=1`
        );
        if (response.ok) {
          const data = await response.json();
          if (data && data.length > 0) {
            const address = data[0].display_name || "";
            const parts = address.split(",");
            return parts[0]?.trim() || null;
          }
        }
      } catch (e) {
        console.warn("Could not fetch suburb name:", e);
      }
      return null;
    }

    function extractPostcode(value) {
      if (!value) return null;
      const match = value.match(/\b\d{4}\b/);
      return match ? match[0] : value.trim();
    }

    // Load postcode dataset
    async function loadPostcodeDataset() {
      if (postcodeDataset) return postcodeDataset;

      try {
        // Get URL from data attribute (set by Liquid template)
        // Falls back to relative path for local development
        const postcodesUrl =
          deliveryEstimate.dataset.postcodesUrl ||
          "/assets/australian-postcodes.json";

        const response = await fetch(postcodesUrl);
        if (response.ok) {
          postcodeDataset = await response.json();
          return postcodeDataset;
        }
      } catch (e) {
        console.warn("Could not load postcode dataset:", e);
      }
      return null;
    }

    // Search postcode suggestions
    function searchPostcodeSuggestions(query) {
      if (!postcodeDataset || !query || query.length === 0) {
        return [];
      }

      const queryStr = query.toString().trim();
      if (queryStr.length === 0 || queryStr.length > 3) {
        return [];
      }

      // Filter postcodes that start with the query
      const matches = postcodeDataset.filter((item) =>
        item.postcode.startsWith(queryStr)
      );

      // Sort by postcode (numerical order)
      matches.sort((a, b) => {
        return parseInt(a.postcode) - parseInt(b.postcode);
      });

      // Limit to 10 results
      return matches.slice(0, 10);
    }

    // Display suggestions
    function displaySuggestions(suggestions) {
      if (!suggestionsList || !suggestionsDiv) return;

      if (!suggestions || suggestions.length === 0) {
        suggestionsDiv.style.display = "none";
        return;
      }

      // Clear existing suggestions
      suggestionsList.innerHTML = "";

      // Create suggestion items
      suggestions.forEach((item, index) => {
        const li = document.createElement("li");
        li.className = "delivery-estimate__suggestion-item";
        li.dataset.postcode = item.postcode;
        li.dataset.index = index;

        // Create postcode span (bold)
        const postcodeSpan = document.createElement("span");
        postcodeSpan.className = "delivery-estimate__suggestion-postcode";
        postcodeSpan.textContent = item.postcode;

        // Create state span (light)
        const stateSpan = document.createElement("span");
        stateSpan.className = "delivery-estimate__suggestion-state";
        stateSpan.textContent = " " + item.state;

        // Append spans directly to li
        li.appendChild(postcodeSpan);
        li.appendChild(stateSpan);

        li.addEventListener("click", () => {
          handleSuggestionClick(item.postcode);
        });

        li.addEventListener("mouseenter", () => {
          selectedSuggestionIndex = index;
          updateSuggestionHighlight();
        });

        suggestionsList.appendChild(li);
      });

      currentSuggestions = suggestions;
      selectedSuggestionIndex = -1;

      // Position suggestions relative to input container
      if (input && inputWrapper) {
        const inputRect = input.getBoundingClientRect();
        const wrapperRect = inputWrapper.getBoundingClientRect();
        const containerRect = deliveryEstimate.getBoundingClientRect();

        suggestionsDiv.style.display = "block";
        // Use inputRect.bottom instead of wrapperRect.bottom for accurate positioning
        suggestionsDiv.style.top = `${
          inputRect.bottom - containerRect.top + 4
        }px`;
        suggestionsDiv.style.left = `${
          wrapperRect.left - containerRect.left
        }px`;
        suggestionsDiv.style.width = `${wrapperRect.width}px`;
      } else {
        suggestionsDiv.style.display = "block";
      }
    }

    // Update suggestion highlight
    function updateSuggestionHighlight() {
      if (!suggestionsList) return;

      const items = suggestionsList.querySelectorAll(
        ".delivery-estimate__suggestion-item"
      );
      items.forEach((item, index) => {
        if (index === selectedSuggestionIndex) {
          item.classList.add("delivery-estimate__suggestion-item--active");
        } else {
          item.classList.remove("delivery-estimate__suggestion-item--active");
        }
      });
    }

    // Handle suggestion click
    function handleSuggestionClick(postcode) {
      if (input) {
        input.value = postcode;
        hideSuggestions();
        calculateShipping(postcode);
      }
    }

    // Hide suggestions
    function hideSuggestions() {
      if (suggestionsDiv) {
        suggestionsDiv.style.display = "none";
      }
      selectedSuggestionIndex = -1;
      currentSuggestions = [];
    }

    // Update suggestions position on scroll/resize
    function updateSuggestionsPosition() {
      if (
        suggestionsDiv &&
        suggestionsDiv.style.display !== "none" &&
        input &&
        inputWrapper
      ) {
        const inputRect = input.getBoundingClientRect();
        const wrapperRect = inputWrapper.getBoundingClientRect();
        const containerRect = deliveryEstimate.getBoundingClientRect();

        // Use inputRect.bottom instead of wrapperRect.bottom for accurate positioning
        suggestionsDiv.style.top = `${
          inputRect.bottom - containerRect.top + 4
        }px`;
        suggestionsDiv.style.left = `${
          wrapperRect.left - containerRect.left
        }px`;
        suggestionsDiv.style.width = `${wrapperRect.width}px`;
      }
    }

    function getShippingRuleForPostcode(postcode, orderTotalCents, productWeight) {
      const code = parseInt(postcode, 10);
      if (Number.isNaN(code)) return null;

      const priceCents = Number(orderTotalCents || 0);

      // Sydney Metro - 2 to 4 business days
      const sydneyMetro = new Set([
        2000,
        2006, 2007, 2008, 2009, 2010, 2011,
        2012, 2013, 2014,
        2015, 2016, 2017, 2018, 2019,
        2020, 2021, 2022, 2023, 2024, 2025,
        2026, 2027, 2028, 2029, 2030, 2031,
        2032, 2033, 2034, 2035, 2036, 2037,
        2038, 2039, 2040, 2041, 2042, 2043,
        2044, 2045, 2046, 2047, 2048, 2049,
        2050,
        2060, 2061, 2062, 2063, 2064, 2065,
        2066, 2067, 2068, 2069, 2070, 2071,
        2072, 2073, 2074, 2075, 2076, 2077,
        2079, 2080, 2081, 2082, 2083, 2084,
        2085, 2086, 2087, 2088, 2089, 2090,
        2091, 2092, 2093, 2094, 2095, 2096,
        2097, 2098, 2099, 2100, 2101, 2102,
        2103, 2104, 2105, 2106, 2107, 2108,
        2109, 2110, 2111, 2112, 2113, 2114,
        2115, 2116, 2117, 2118, 2119, 2120,
        2121, 2122, 2123, 2124, 2125, 2126,
        2127, 2128, 2129, 2130, 2131, 2132,
        2133, 2134, 2135, 2136, 2137, 2138,
        2139, 2140, 2141, 2142, 2143, 2144,
        2145, 2146, 2147, 2148, 2149, 2150,
        2151, 2152, 2153, 2154, 2155, 2156,
        2157,
        2158,
        2159,
        2160, 2161, 2162, 2163, 2164, 2165,
        2166, 2167, 2168,
        2170, 2171, 2172, 2173, 2174, 2175,
        2176, 2177, 2178, 2179,
        2180, 2182, 2183, 2184, 2186, 2187, 2188, 2189,
        2190, 2191, 2192, 2193, 2194, 2195,
        2196, 2197, 2198, 2199, 2200,
        2202,
        2203, 2204, 2205, 2206, 2207, 2208,
        2209, 2210, 2211, 2212, 2213, 2214,
        2215,
        2216, 2217, 2218, 2219, 2220, 2221,
        2222, 2223, 2224, 2225, 2226, 2227,
        2228, 2229, 2230, 2231, 2232, 2233,
        2234,
        2555, 2556, 2557, 2558, 2559, 2560, 2565,
        2745, 2762, 2763, 2765, 2766,
        2783
      ]);

      // Melbourne Metro - 4 to 8 business days
      const melbourneMetro = new Set([
        3000, 3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008, 3009,
        3010, 3011, 3012, 3013, 3014, 3015, 3016, 3017, 3018,
        3019, 3020, 3021, 3022, 3023, 3024, 3025,
        3026, 3027, 3028, 3029, 3030, 3031, 3032,
        3033, 3034, 3035, 3036, 3037, 3038, 3039, 3040,
        3041, 3042, 3043, 3044, 3045, 3046, 3047,
        3048, 3049, 3050, 3051, 3052, 3053, 3054,
        3055, 3056, 3057, 3058, 3059, 3060, 3061,
        3062, 3063, 3064, 3065, 3066, 3067, 3068,
        3069,
        3070, 3071, 3072, 3073, 3074, 3075, 3076,
        3077, 3078, 3079, 3080, 3081, 3082, 3083, 3084, 3085,
        3086, 3087, 3088, 3089, 3090, 3091, 3093,
        3092, 3094, 3095, 3096, 3097, 3098, 3099, 3100, 3101, 3102, 3103, 3104,
        3105, 3106, 3107, 3108, 3109, 3111, 3113,
        3110, 3112, 3114, 3115, 3116, 3117, 3118, 3119, 3120, 3121, 3122, 3123, 3124,
        3125, 3126, 3127, 3128, 3129, 3130, 3131,
        3132, 3133, 3134, 3135, 3136, 3137, 3138,
        3139, 3140, 3141, 3142, 3143, 3144, 3145, 3146,
        3147, 3148, 3149, 3150, 3151, 3152, 3153,
        3154, 3155, 3156, 3157, 3158, 3159, 3160, 3161, 3162, 3163, 3164, 3165,
        3166, 3167, 3168, 3169, 3170, 3171, 3172, 3173,
        3174, 3175, 3176, 3177, 3178, 3179, 3180, 3181,
        3182, 3183, 3184, 3185, 3186, 3187, 3188,
        3189, 3190, 3191, 3192, 3193, 3194, 3195,
        3196, 3197, 3198, 3199, 3200, 3201, 3202,
        3203,
        3204, 3205, 3206, 3207, 3750, 3782, 3802, 3805, 3975, 3976, 3977,
      ]);

      // Geelong area - 3 to 6 business days
      const geelongArea = new Set([3214, 3215, 3216, 3217, 3218, 3219, 3220]);

      // Brisbane Metro - 6 to 9 business days
      const brisbaneMetro = new Set([
        4000, 4005, 4006, 4007, 4008, 4010, 4011, 4012, 4013, 4014, 4017, 4018,
        4030, 4031, 4032, 4034, 4036, 4051, 4053, 4055, 4059, 4060, 4061, 4064,
        4065, 4070, 4101, 4102, 4103, 4110, 4113, 4114, 4115, 4151, 4152, 4153, 4160,
        4161, 4169, 4170, 4171, 4172, 4173, 4174, 4175, 4176, 4177, 4178, 4179,
      ]);

      // NSW regional paid areas - 3 to 6 business days
      const centralCoast = new Set([
        2250, 2251, 2256, 2257, 2260, 2258, 2259, 2261, 2262, 2263,
      ]);

      const blueMountains = new Set([
        2758, 2773, 2774, 2776, 2777, 2778, 2779, 2780, 2782,
        2784, 2785,
      ]);

      const wollongongKiama = new Set([
        2527, 2528, 2529, 2500, 2502, 2505, 2506, 2508,
        2515, 2516, 2517, 2518, 2519, 2520, 2526,
      ]);

      const maitlandNewcastle = new Set([
        2320, 2325, 2283, 2321, 2323, 2326, 2327, 2335,
        2267, 2268, 2278, 2280, 2281, 2282, 2284, 2285,
        2286, 2290, 2306, 2264, 2265, 2287, 2289, 2291,
        2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299,
        2300, 2302, 2303, 2304, 2305, 2307, 2308,
        2318, 2322, 2315, 2316, 2317, 2319, 2324,
      ]);

      const berryNowra = new Set([2533, 2535, 2540, 2541]);

      // Southern Highlands - 3 to 8 business days
      const southernHighlands = new Set([
        2570, 2571, 2572, 2573, 2574, 2575, 2576, 2577, 2578,
      ]);

      // Canberra & ACT area - 3 to 6 business days
      const canberraAct = new Set([
        2620, 2912, 2913, 2914, 2911, 2615, 2614, 2617,
        2602, 2600, 2612, 2604, 2609, 2605, 2606, 2607,
        2611, 2903, 2902, 2900, 2905, 2906, 2619,
      ]);

      const collectAddress = "45 Britton St, Smithfield, 2164";
      const shippingFee = calculateShippingFee(priceCents);

      if (sydneyMetro.has(code)) {
        return {
          total_price: shippingFee,
          delivery_days: "2 to 4 business days",
          collect_address: collectAddress,
        };
      }

      if (melbourneMetro.has(code)) {
        return {
          total_price: shippingFee,
          delivery_days: "4 to 8 business days",
          collect_address: collectAddress,
        };
      }

      if (brisbaneMetro.has(code)) {
        return {
          total_price: shippingFee,
          delivery_days: "6 to 9 business days",
          collect_address: collectAddress,
        };
      }

      if (
        centralCoast.has(code) ||
        blueMountains.has(code) ||
        wollongongKiama.has(code) ||
        maitlandNewcastle.has(code) ||
        berryNowra.has(code)
      ) {
        return {
          total_price: shippingFee,
          delivery_days: "3 to 6 business days",
          collect_address: collectAddress,
        };
      }

      if (southernHighlands.has(code)) {
        return {
          total_price: shippingFee,
          delivery_days: "3 to 8 business days",
          collect_address: collectAddress,
        };
      }

      if (geelongArea.has(code) || canberraAct.has(code)) {
        return {
          total_price: shippingFee,
          delivery_days: "3 to 6 business days",
          collect_address: collectAddress,
        };
      }

      return null;
    }

    async function resolveOrderTotalCents() {
      if (isCartContext(deliveryEstimate)) {
        try {
          const cartResponse = await fetch("/cart.js");
          const cart = await cartResponse.json();
          if (cart && Number.isFinite(cart.total_price)) {
            deliveryEstimate.dataset.productPrice = String(cart.total_price);
            return cart.total_price;
          }
        } catch (error) {
          // Fall back to server-rendered cart total.
        }
      }

      return parseInt(deliveryEstimate.dataset.productPrice || "0", 10);
    }

    async function calculateShipping(postcode) {
      if (!postcode || !/^\d{4}$/.test(postcode)) {
        hideAllMessages();
        showPlainError(
          errorDiv,
          "Please enter a valid 4-digit Australian postcode"
        );
        return;
      }

      hideAllMessages();
      if (loadingDiv) loadingDiv.style.display = "block";

      try {
        const orderTotalCents = await resolveOrderTotalCents();
        const productWeight = 0;

        const rule = getShippingRuleForPostcode(
          postcode,
          orderTotalCents,
          productWeight
        );

        const shippingRates = rule ? [rule] : [];

        hideAllMessages();

        if (shippingRates.length > 0) {
          const stateInfo = getStateFromPostcode(postcode);
          let suburbName = await getSuburbFromPostcode(postcode);

          if (!suburbName && shippingRates[0].suburb) {
            suburbName = shippingRates[0].suburb;
          }
          if (!suburbName && shippingRates[0].city) {
            suburbName = shippingRates[0].city;
          }

          // Only show State and Postcode, not suburb
          let locationString = "";
          if (stateInfo) {
            locationString = `${stateInfo.code} ${postcode}`;
          } else {
            locationString = postcode;
          }

          const titleText = deliveryEstimate.querySelector(
            ".delivery-estimate__title-text"
          );
          const locationSpan = deliveryEstimate.querySelector(
            ".delivery-estimate__location"
          );
          const locationValue = deliveryEstimate.querySelector(
            ".delivery-estimate__location-value"
          );
          const locationText = deliveryEstimate.querySelector(
            ".delivery-estimate__location-text"
          );
          const link = deliveryEstimate.querySelector(
            ".delivery-estimate__link"
          );

          if (titleText && locationSpan && locationValue && locationText) {
            titleText.style.display = "none";
            locationSpan.style.display = "inline";
            locationText.textContent = locationString;
            // Hide "Enter Postcode" link when showing result
            if (link) {
              link.style.display = "none";
            }
          }

          if (input) {
            input.value = locationString;
          }

          const rate = shippingRates[0];
          const price = parseFloat(rate.total_price || rate.price || 0);
          const priceFormatted = price > 0 ? `$${price.toFixed(2)}` : "Free";

          const shippingPrice = resultDiv?.querySelector(
            ".delivery-estimate__shipping-price"
          );
          if (shippingPrice) {
            shippingPrice.textContent = priceFormatted;
          }

          const deliveryDays = resultDiv?.querySelector(
            ".delivery-estimate__delivery-days"
          );
          if (deliveryDays) {
            if (rate.delivery_date) {
              deliveryDays.textContent = rate.delivery_date;
            } else if (rate.estimated_delivery) {
              deliveryDays.textContent = rate.estimated_delivery;
            } else if (rate.delivery_days) {
              deliveryDays.textContent = rate.delivery_days;
            } else {
              deliveryDays.textContent = "4-6 days";
            }
          }

          const clickCollect = resultDiv?.querySelector(
            ".delivery-estimate__click-collect"
          );
          const collectAddress = resultDiv?.querySelector(
            ".delivery-estimate__collect-address"
          );
          if (clickCollect && collectAddress) {
            const address =
              rate.collect_address ||
              rate.pickup_address ||
              "45 Britton St, Smithfield, 2164";
            collectAddress.textContent = address;
            clickCollect.style.display = "flex";
          }

          if (resultDiv) {
            resultDiv.style.display = "block";
            hasResult = true;
          }

          if (!isExpanded) {
            toggleExpand();
          }

          if (isCartContext(deliveryEstimate)) {
            try {
              localStorage.setItem(CART_POSTCODE_STORAGE_KEY, postcode);
            } catch (e) {}
          }
        } else {
          hasResult = false;
          showOutOfZoneError(errorDiv, postcode);
        }
      } catch (error) {
        console.error("Error calculating shipping:", error);
        hideAllMessages();
        showPlainError(
          errorDiv,
          "Unable to calculate delivery. Please try again later."
        );
      }
    }

    function handleInput() {
      let inputValue = input.value.trim();

      if (hasResult) {
        hasResult = false;
        if (resultDiv) {
          resultDiv.style.display = "none";
        }
        const titleText = deliveryEstimate.querySelector(
          ".delivery-estimate__title-text"
        );
        const locationSpan = deliveryEstimate.querySelector(
          ".delivery-estimate__location"
        );
        const link = deliveryEstimate.querySelector(".delivery-estimate__link");
        if (titleText && locationSpan) {
          titleText.style.display = "inline";
          locationSpan.style.display = "none";
          // Show "Enter Postcode" link again when user starts editing
          if (link) {
            link.style.display = "inline-flex";
          }
        }
      }

      // Only allow digits
      const digitsOnly = inputValue.replace(/\D/g, "");
      if (inputValue !== digitsOnly) {
        input.value = digitsOnly;
        inputValue = digitsOnly;
      }

      if (inputValue && /^\d+$/.test(inputValue)) {
        if (inputValue.length > 4) {
          input.value = inputValue.substring(0, 4);
          inputValue = inputValue.substring(0, 4);
        }
      }

      hideAllMessages();

      // Clear existing timers
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      if (autocompleteDebounceTimer) {
        clearTimeout(autocompleteDebounceTimer);
      }

      const postcode = extractPostcode(inputValue);

      // If 4 digits, trigger shipping calculation
      if (postcode && /^\d{4}$/.test(postcode)) {
        hideSuggestions();
        debounceTimer = setTimeout(() => {
          calculateShipping(postcode);
        }, 500);
      }
      // If 1-3 digits, show autocomplete suggestions
      else if (inputValue && /^\d{1,3}$/.test(inputValue)) {
        autocompleteDebounceTimer = setTimeout(async () => {
          // Ensure dataset is loaded
          await loadPostcodeDataset();
          const suggestions = searchPostcodeSuggestions(inputValue);
          displaySuggestions(suggestions);
        }, 300);
      }
      // If empty or invalid, hide suggestions
      else {
        hideSuggestions();
      }
    }

    // Load postcode dataset on init
    loadPostcodeDataset();

    header.addEventListener("click", toggleExpand);

    if (input) {
      input.addEventListener("click", function (e) {
        e.stopPropagation();
      });

      input.addEventListener("input", handleInput);

      // Handle keyboard navigation
      input.addEventListener("keydown", function (e) {
        if (!suggestionsDiv || suggestionsDiv.style.display === "none") {
          // If suggestions not visible, handle Enter normally
          if (e.key === "Enter") {
            e.preventDefault();
            const inputValue = input.value.trim();
            const postcode = extractPostcode(inputValue);
            if (postcode && /^\d{4}$/.test(postcode)) {
              calculateShipping(postcode);
            }
          }
          return;
        }

        // Handle arrow keys and Enter when suggestions are visible
        if (e.key === "ArrowDown") {
          e.preventDefault();
          if (currentSuggestions.length > 0) {
            selectedSuggestionIndex =
              selectedSuggestionIndex < currentSuggestions.length - 1
                ? selectedSuggestionIndex + 1
                : 0;
            updateSuggestionHighlight();
          }
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          if (currentSuggestions.length > 0) {
            selectedSuggestionIndex =
              selectedSuggestionIndex > 0
                ? selectedSuggestionIndex - 1
                : currentSuggestions.length - 1;
            updateSuggestionHighlight();
          }
        } else if (e.key === "Enter") {
          e.preventDefault();
          if (
            selectedSuggestionIndex >= 0 &&
            selectedSuggestionIndex < currentSuggestions.length
          ) {
            const selectedPostcode =
              currentSuggestions[selectedSuggestionIndex].postcode;
            handleSuggestionClick(selectedPostcode);
          } else {
            // If no suggestion selected, try to calculate with current input
            const inputValue = input.value.trim();
            const postcode = extractPostcode(inputValue);
            if (postcode && /^\d{4}$/.test(postcode)) {
              hideSuggestions();
              calculateShipping(postcode);
            }
          }
        } else if (e.key === "Escape") {
          e.preventDefault();
          hideSuggestions();
          input.blur();
        }
      });

      // Legacy keypress handler for Enter (when suggestions not visible)
      input.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
          // This will be handled by keydown if suggestions are visible
          if (!suggestionsDiv || suggestionsDiv.style.display === "none") {
            e.preventDefault();
            const inputValue = input.value.trim();
            const postcode = extractPostcode(inputValue);
            if (postcode && /^\d{4}$/.test(postcode)) {
              calculateShipping(postcode);
            }
          }
        }
      });
    }

    // Click outside to close suggestions
    document.addEventListener("click", function (e) {
      if (
        suggestionsDiv &&
        suggestionsDiv.style.display !== "none" &&
        !deliveryEstimate.contains(e.target)
      ) {
        hideSuggestions();
      }
    });

    // Update suggestions position on scroll/resize
    window.addEventListener("scroll", updateSuggestionsPosition, true);
    window.addEventListener("resize", updateSuggestionsPosition);

    // Trên cart: chỉ khôi phục postcode khi init sau cart update (AJAX). Khi refresh trang thì clear và không khôi phục.
    if (isCartContext(deliveryEstimate)) {
      try {
        if (options.restorePostcode) {
          const savedPostcode = localStorage.getItem(CART_POSTCODE_STORAGE_KEY);
          if (savedPostcode && /^\d{4}$/.test(savedPostcode) && input) {
            input.value = savedPostcode;
            setTimeout(function () {
              calculateShipping(savedPostcode);
            }, 0);
          }
        } else {
          localStorage.removeItem(CART_POSTCODE_STORAGE_KEY);
        }
      } catch (e) {}
    }

    if (deliveryEstimate.dataset.autoExpand === "true" && !isExpanded) {
      toggleExpand();
    }
  }

  // Initialize all delivery estimate components on the page
  // options.restorePostcode: true = khôi phục postcode (sau cart update), false/undefined = không khôi phục (refresh trang → clear)
  function initAllDeliveryEstimates(options) {
    options = options || {};
    const deliveryEstimates = document.querySelectorAll(".delivery-estimate");
    deliveryEstimates.forEach((element) => {
      if (element.closest("#delivery-estimate-shortcode-template")) return;

      const blockId = element.id;
      const linkText = element.dataset.linkText || "Enter Postcode";
      const placeholderText =
        element.dataset.placeholder || "Enter suburb/postcode";
      initDeliveryEstimate(blockId, linkText, placeholderText, options);
    });
  }

  window.CedoraDeliveryEstimate = {
    initAll: initAllDeliveryEstimates,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllDeliveryEstimates({ restorePostcode: false });
    });
  } else {
    initAllDeliveryEstimates({ restorePostcode: false });
  }

  // Sau khi cart update (quantity change), MainCart innerHTML bị thay thế → block delivery-estimate mới cần init lại và recalc theo cart mới
  document.addEventListener("cart:updated", function () {
    initAllDeliveryEstimates({ restorePostcode: true });
  });
})();
